export const REGION = "region"
export const COUNTY = "county"
export const STORE = "store"
export const FORMAT = "format"

export const PARAMETER_KEYS: Record<string, string> = {
	regions: "region",
	counties: "county",
	stores: "store",
	formats: "formats",
	brands: "brands",
	departments: "departments",
	categories: "categories",
	subcategories: "subcategories",
	vendors: "vendors",
	products: "products",
	age: "age",
	gender: "gender",
	segmentation: "segmentation",
	channel: "channel",
	psychographics: "psychographics",
	fineline: "fineline",
	item: "item",
	interval: "interval",
	customer_type: "customer_type",
}
